import { DEFAULT_SIZE, START_DELAY, STRIPE_MIN_HEIGHT, STRIPES_COUNT } from './config'
import { IAppLoaderSvgProps, IStripeStyles } from './interfaces'

import styles from './AppLoaderSvg.module.scss'

export const AppLoaderSvg = ({ size = DEFAULT_SIZE }: IAppLoaderSvgProps) => {
  const getStripeStyles = (index: number): IStripeStyles => ({
    '--peak': `${size - STRIPE_MIN_HEIGHT}px`,
    animationDelay: `${index * START_DELAY}s`,
  })

  return (
    <svg width={size} height={size}>
      {Array.from({ length: STRIPES_COUNT }).map((_, i) => (
        <rect
          key={`appLoaderSvg-${i}`}
          x={(size / STRIPES_COUNT) * i}
          height={size}
          className={styles.stripe}
          style={getStripeStyles(i)}
        />
      ))}
    </svg>
  )
}
